import { useState } from "react";

const CertificationTransferListing = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  return (
    <div className="container ">
      <h5 className="fw-bold mb-3" style={{borderBottom:'2px solid #90b732', color:'#90b732', paddingBottom:'8px', fontSize:'17px'}}>Certification Transfer Listing</h5>

      {/* Toolbar */}
      <div className="d-flex justify-content-between align-items-center mb-2 p-2 border">
        <div>
          <button className="btn btn-sm btn-light" onClick={() => console.log("Filters clicked")}>
            <i className="bi bi-funnel-fill "></i><span className="text-primary fw-bold"> Filters / Options</span>
          </button>
        </div>

        <div className="d-flex align-items-center">
          <span className="me-2">Page:</span>
          <input
            type="number"
            className="form-control form-control-sm me-2"
            style={{ width: "60px" }}
            value={page}
            onChange={(e) => setPage(Number(e.target.value))}
          />
          <span className="me-2">of 1</span>

          <span className="me-2">Page Size:</span>
          <input
            type="number"
            className="form-control form-control-sm me-2"
            style={{ width: "60px" }}
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />

          <button className="btn btn-light border border-dark btn-sm" onClick={() => console.log("Transfer clicked")}>
            Certification Transfer
          </button>
        </div>
      </div>

      {/* Table */}
      <table className="table table-bordered table-striped text-center">
        <thead style={{background:'#90b732', color:'#fff'}}>
          <tr>
            <th>Certificate Name</th>
            <th>Opening Quantity</th>
            <th>Inward Quantity</th>
            <th>Outward Quantity</th>
            <th>Closing Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={5}>No Related Data !</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CertificationTransferListing;
